import { combineReducers } from 'redux';

import accountingSettings from './accountingSettings.reducer';
import advisorPortalConfigurations from './advisorPortalConfigurations.reducer';
import customQuestions from './applyFormCustomQuestions.reducer';
import customQuestionsSchema from './applyFormCustomQuestions.schema.reducer';
import audioRecordings from './audioRecordings.reducer';
import authMethodConfig from './authMethodConfig.reducer';
import businessDays from './businessDays.reducer';
import companies from './companies.reducer';
import companyIpWhitelist from './companyIpWhitelist.reducer';
import companyProperties from './companyProperties.reducer';
import companyPropertiesSettled from './companyPropertiesSettled.reducer';
import compensationCompliance from './compensationCompliance.reducer';
import contactsPresentation from './contactsPresentation.reducer';
import csvMappingsDefinition from './csvMappingsDefinition.reducer';
import csvMappingsMetadata from './csvMappingsMetadata.reducer';
import csvMappingsProperties from './csvMappingsProperties.reducer';
import domains from './domains.reducer';
import emailSignature from './emailSignature.reducer';
import emailSnippets from './emailSnippets.reducer';
import formFieldData from './formFieldData.reducer';
import leadSources from './leadSources.reducer';
import licensedStates from './licensedStates.reducer';
import loanOfficersManagement from './loanOfficersManagement.reducer';
import localizationStrings from './localizationStrings.reducer';
import mobileAppRelease from './mobileAppRelease.reducer';
import msr from './msr.reducer';
import nmlsLicenses from './nmlsLicenses.reducer';
import obConfig from './obConfig.reducer';
import phoneNumbers from './phoneNumbers.reducer';
import posConfigurations from './posConfigurations.reducer';
import properties from './properties.reducer';
import propertyDefinitions from './propertyDefinitions.reducer';
import sso from './sso.reducer';
import telnyxPhoneNumbers from './telnyxPhoneNumbers.reducer';
import tpoDenialConfiguration from './tpoDenialConfiguration.reducer';
import tpoSignupConfigurations from './tpoSignupConfigurations.reducer';
import tpoSignupStepConditionExpressionSchema from './tpoSignupStepConditionExpressionSchema.reducer';
import whitelist from './whitelist.reducer';

const reducer = {
  companies,
  company: combineReducers({
    domains,
    properties,
    companyProperties,
    companyPropertiesSettled,
    compensationCompliance,
    propertyDefinitions,
    licensedStates,
    nmlsLicenses,
    emailSignature,
    emailSnippets,
    leadSources,
    sso,
    authMethodConfig,
    accountingSettings,
    csvMappingsDefinition,
    csvMappingsMetadata,
    csvMappingsProperties,
    audioRecordings,
    loanOfficersManagement,
    localizationStrings,
    msr,
    obConfig,
    phoneNumbers,
    posConfigurations,
    tpoDenialConfiguration,
    tpoSignupConfigurations,
    tpoSignupStepConditionExpressionSchema,
    advisorPortalConfigurations,
    customQuestions,
    customQuestionsSchema,
    businessDays,
    contactsPresentation,
    formFieldData,
    telnyxPhoneNumbers,
    whitelist,
    companyIpWhitelist,
    mobileAppRelease,
  }),
};

export default reducer;
